import {noop} from '@benchling/js-utils';
import React, {useEffect} from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import ChemicalCounterpartLibrary, {ChemicalCounterpartItem} from 'chemistry/ChemicalCounterpartLibrary';
import {TABLE_KEYS} from 'ui-library/scrollable/ScrollableTableConstants';

// Temporary mock data; once APIs are implemented this should come from GQL or similar. See MonomerListing for an example.
const STUB_SOLVATES: Array<ChemicalCounterpartItem> = [
  {
    id: 'slvt_k8vTsL3m',
    name: 'Water',
    counterpartType: 'Hydrate',
    code: 'HY',
    molecularFormula: 'H₂O',
    molecularWeight: 18.02,
    canonicalSmiles: 'O',
  },
  {
    id: 'slvt_j3dNpF9q',
    name: 'Ethanolate',
    counterpartType: 'Solvate',
    code: 'EtOH',
    molecularFormula: 'C₂H₅OH',
    molecularWeight: 58.08,
    canonicalSmiles: 'CCO',
  },
  {
    id: 'slvt_w5cMhB2x',
    name: 'DMSO',
    counterpartType: 'Solvate',
    code: 'DMSO',
    molecularFormula: 'C₂H₆OS',
    molecularWeight: 78.13,
    canonicalSmiles: 'CS(C)=O',
  },
];

export default function SolvateLibrary(): JSX.Element {
  useEffect(() => {
    setWindowTitle('Solvates');
  }, []);

  return (
    <ChemicalCounterpartLibrary
      title="Solvate library"
      addNewLabel="Add new solvate"
      items={STUB_SOLVATES}
      tableKey={TABLE_KEYS.SOLVATE_LIBRARY_TABLE}
      searchPlaceholder="Solvate name or code"
      onAddNew={noop}
    />
  );
}
